import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useConversion, useStandards } from 'hooks';
import { COLORS } from '../../constants';
const TargetZone = ({ innerWidth, yScale, criticalLow = 0, criticalHigh = 0, isInProgress })=>{
    const standards = useStandards();
    const conversion = useConversion('bloodGlucoseConcentration');
    if (isInProgress) {
        return null;
    }
    const lowPreMealThreshold = conversion.toDisplay(standards.preMeal.lowThreshold);
    const highPreMealThreshold = conversion.toDisplay(standards.preMeal.highThreshold);
    const lowPostMealThreshold = conversion.toDisplay(standards.postMeal.lowThreshold);
    const highPostMealThreshold = conversion.toDisplay(standards.postMeal.highThreshold);
    const convCriticalLow = criticalLow && conversion.toDisplay(criticalLow);
    const convCriticalHigh = criticalHigh && conversion.toDisplay(criticalHigh);
    const width = innerWidth;
    const yTopPreMeal = yScale(highPreMealThreshold);
    const yBottomPreMeal = yScale(lowPreMealThreshold);
    const yTopPostMeal = yScale(highPostMealThreshold);
    const yBottomPostMeal = yScale(lowPostMealThreshold);
    const yTopCriticalHigh = yScale(convCriticalHigh);
    const yBottomCriticalLow = yScale(convCriticalLow);
    return /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                y: yTopPreMeal,
                width: width,
                height: yBottomPreMeal - yTopPreMeal,
                fill: "rgba(48, 235, 158, 0.15)"
            }),
            /*#__PURE__*/ _jsx("rect", {
                y: yTopPostMeal,
                width: width,
                height: yBottomPostMeal - yTopPostMeal,
                fill: "rgba(48, 235, 158, 0.1)"
            }),
            convCriticalHigh && /*#__PURE__*/ _jsx("line", {
                x1: "0",
                y1: yTopCriticalHigh,
                x2: width,
                y2: yTopCriticalHigh,
                style: {
                    stroke: COLORS.high
                }
            }),
            convCriticalLow && /*#__PURE__*/ _jsx("line", {
                x1: "0",
                y1: yBottomCriticalLow,
                x2: width,
                y2: yBottomCriticalLow,
                style: {
                    stroke: COLORS.low
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "0",
                y1: yTopPostMeal,
                x2: width,
                y2: yTopPostMeal,
                style: {
                    stroke: COLORS.high
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                strokeDasharray: "10, 5",
                x1: "0",
                y1: yTopPreMeal,
                x2: width,
                y2: yTopPreMeal,
                style: {
                    stroke: COLORS.high
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "0",
                y1: yBottomPostMeal,
                x2: width,
                y2: yBottomPostMeal,
                style: {
                    stroke: COLORS.low
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                strokeDasharray: "10, 5",
                x1: "0",
                y1: yBottomPreMeal,
                x2: width,
                y2: yBottomPreMeal,
                style: {
                    stroke: COLORS.low
                }
            })
        ]
    });
};
export default /*#__PURE__*/ memo(TargetZone);
